const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/multi-page-hand-gathering-configurations`,
    saveSpeedTable: `${API_URL}/multi-page-hand-gathering-configuration/save-speed-table`
};

export default apiUrls;
